import axios from '@_system/axios/axios.js'
export default {
	path: '/bankaccount',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	copyBycode(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/copyBycode', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	updatebankinfo(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/updatebankinfo', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listhistorysum(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/listhistorysum', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	recordremain(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/recordremain', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	send(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/send', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/bankaccount.bankaccount', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},

	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
